import {Component, OnInit} from '@angular/core';
import {FPhi} from '@facephi/selphid-widget-web';
import { FacephiService } from '../../../Services/facephi.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-v3',
    templateUrl: './v3.component.html',
    styleUrls: ['./v3.component.scss']
})
export class V3Component  implements OnInit{

     //navegador compatible
    private videoDevices: boolean;
    private wasm: boolean;

    constructor(
        private facephiService: FacephiService
    ) { }

    fPhiSelphIdConstants = FPhi.SelphID;
    objectEntriesFunc = Object.entries;

    ngOnInit(): void {
        const Compro = this.fPhiSelphIdConstants.CheckCapabilities();
        this.videoDevices = Compro['video_devices'];
        this.wasm = Compro['wasm'];
    }

    readonly FPhiCameraResolutions = {
        res480p: {title: '640x480', width: 640, height: 480},
        res600p: {title: '800x600', width: 800, height: 600},
        res768p: {title: '1024x768', width: 1024, height: 768},
        res720p: {title: '1280x720 (720p)', width: 1280, height: 720},
        res1080p: {title: '1920x1080 (1080p)', width: 1920, height: 1080},
    };

    isWidgetCaptureStarted = false;


    widgetCaptureMode: number = FPhi.SelphID.Mode.Full;
    widgetCameraResolution = 'res720p';
    //widgetCaptureSensibility: number = FPhi.SelphID.CaptureSensibility.Auto;
    widgetCaptureSensibility: number = FPhi.SelphID.CaptureSensibility.High;
    widgetPreviewCapture = true;
    widgetForceLandscape = false;
    widgetInitialTip = true;
    widgetDebugMode = false;
    widgetVideoRecord = false;
    widgetShowLog = false;
    widgetStartSimpleMode = true;
    widgetContainerWidth = '100%';
    widgetContainerHeight = '100%';
    //produccion
    widgetLicenseKey = "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";
    //localhost
    //widgetLicenseKey = "3D430010231C062B0411476A4A2F2702063538014B6A43070A331D04230F173129180C645B4129390B0C281206203E1E0C2A0E130072444B2A0800003E1B0C645B18473307042B040D11234A5364434F4734091D23240D0172524B745151567D595B6B5050477C4A0C3E15110414091D27435947632C5D75512555135B5A76255352635D5972535455115B5A77255351625B5900505451675E2872205224615C587053515764595875505156625C5B705422551658507527525462515975545357125E597720575362295B03525055625B2F72565220675D5C7253535465592876555020602C5B76532655665A5173515255615D5A7E545455685A597652522362515B04542155115B5D75535021602D5C75525A5761592A76505354632E5A04505257135E5D7520532462515B02515255675B2D77595621662C5A04505456635A5174525121635E5C725050541359587724515D635D5A70512254145E5973505054675B5C74545751115E5A73235320615C590351555062595F7252515563595C75505054625B5B7625525562515D03515655155E5E75585152622E5B73525357695B5D74525354615C5A77545755635B2876225152632D5A71555B5767595A7656502062585974512756675B2D74205123615E5B73525056615E5F75225227622A5A71512150615B2C745056216258597F522250615958762551516258597151515115592F75595023615D5903515A50135A5977595324622E5C7152505766595074545654632D5D0751275562585C75245153615F5C7451215767595B7456515660295B00532656625F2B73505150672E5870505A54135A597256562162585A73515A5467585E7450565560595B04532151155F2F7725575362595C77502255605B2F72205750665C5902512255665B5C76575224625B5A73512055155B5C7657512162515974505555685B5C76575221665C5C0455525415582A72205324635B5874505455115B2D7625522761295D75545A56695F5B7424535D625D5972525055145B507555572766295A02555255615B2F76235226622A597251275461585D7750525C625B5A0255525016582A72205150622E5974515555125A5A7625512662505871515555695B2F7759532661295D75552556695F5B76555355625D5972512754665B5C75555727672B5807522551675B5A76565351622A5972512754615A5A75555727672B5A02555256695F5B72555050665C5973515154615B5C74255352625A5A0255525016582A72205627675E5C75545351685E5873205751675F5C74522551675F2A755557276229597E515355605B2C77235326605A5903515354605B2D76255352635A5A0255525016582A72205224615C587053515764595875505156625C5B705422551658507527525462515975545357125E597720575362295B03525055625B2F72565220675D5C7253535465592876555020602C5B76532655665A5173515255615D5A7E545455685A597652522362515B04542155115B5D75535021602D5C75525A5761592A76505354632E5A04505257135E5D7520532462515B02515255675B2D77595621662C5A04505456635A5174525121635E5C725050541359587724515D635D5A70512254145E5973505054675B5C74545751115E5A73235320615C590351555062595F7252515563595C75505054625B5B7625525562515D03515655155E5E75585152622E5B73525357695B5D74525354615C5A77545755635B2876225152632D5A71555B5767595A7656502062585974512756675B2D74205123615E5B73525056615E5F75225227622A5A71512150615B2C745056216258597F522250615958762551516258597151515115592F75595023615D5903515A50135A5977595324622E5C7152505766595074545654632D5D0751275562585C75245153615F5C7451215767595B7456515660295B00532656625F2B73505150672E5870505A54135A597256562162585A73515A5467585E7450565560595B04532151155F2F7725575362595C77502255605B2F7555572766295A02555254655B5876235357625F5970515557125B587654532661295D75545A56695F5B76555353625D5976512555145B2F7723522161295D75552556695F5B762553526259597E51275560585D7750525C625B5A0255525016582A72205151622E5974505255115B5B7655535562505907522551675F2A75555727635E5875512055615A5C7623522161295D75545A56695F5B752353266229587751215713595D7555572766295A02555254635B5C77205224622E5903512756695F5B73535050665C5C7655275065582A7220525166295A02555254655A5B76565223622E597351555467582A7220565661295D75535655645B5A7625505C622D597E522551675A2D72205750665C5902512055625B5E7650535262595D75545A55635B5876555224625B5D02555255605B2C7627535562505972525454135A5976255727672B5D75532655135B5A77205353625C5902512255125B2B7220525172444B2A0800003E1B0C020E00103D0D0732435911221D0C6A430F0C330D07350425043301082A43590331041A234D4109390B0C281206313F030C28250C0625050C2815415F241A1C234D41093F0F0E2F0F04476A0E082A12064972071A645B41243E114B6A43130433030821042D043D0D4B7C430F0A3309052E0E101172444B230F040C3E0D3D3F1106476A4A242F02110A320400280A414972181B29051606244A536432060920002002434F47260D1B35080C0B72524B774F53472D444B36130C13390C0C3443594716090A23310B0C7215";
    get widgetCameraWidth(): number {
        return this.FPhiCameraResolutions[this.widgetCameraResolution].width;
    }

    get widgetCameraHeight(): number {
        return this.FPhiCameraResolutions[this.widgetCameraResolution].height;
    }

    startSimpleMode() {
        this.widgetStartSimpleMode = true;
        this.isWidgetCaptureStarted = true;
    }

    onStartCapture() {
        if( this.videoDevices == false || this.wasm == false ) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Su navegador no es compatible`,
                confirmButtonColor: '#001b71'
              });
        }else {
            if (this.widgetForceLandscape) {
                this.widgetContainerHeight = '56.25%';
                this.widgetContainerWidth = '100%';
            } else {
                this.widgetContainerWidth = '100%';
                this.widgetContainerHeight = '100%';
            }
    
            if (this.widgetLicenseKey === "") {
                this.widgetLicenseKey = window.prompt("Please, enter the license key before start the operations: ", "")
            }
    
            this.widgetStartSimpleMode = false;
            this.isWidgetCaptureStarted = true;
        }
    }

    onStopCapture() {
        this.widgetStartSimpleMode = false;
        this.isWidgetCaptureStarted = false;
    }

    // Widget event handlers
    onModuleLoaded(eventData) {
        console.warn('[SelphID] onModuleLoaded', eventData);
    }

   async onExtractionFinished(extractionResult) {

        const backResult = extractionResult.detail.images[1].src|| null;
        const frontResult = extractionResult.detail.images[0].src || null;
        let images = []

        if (frontResult !== null) images.push({ imagen: await this.resizedataURL(frontResult,500,400) })
        if (backResult !== null)  images.push({ imagen: await this.resizedataURL(backResult,500,400) })

        
        //==============Onboarding====================
        if( this.facephiService.isOnbarding['_value']){
            console.log("imagenes ", images)
            this.facephiService.setImagesDoc(images);
        }else {
        //==============FIN Onboarding====================
     
            //consumir API para hacer la validacion de los documentos
            this.facephiService.setResponseDocument(images)    
        }


        this.widgetStartSimpleMode = false;
        this.isWidgetCaptureStarted = false;
    }

    onUserCancelled() {
        console.warn('[SelphID] onUserCancelled');
        this.widgetStartSimpleMode = false;
        this.isWidgetCaptureStarted = false;
    }

    onExceptionCaptured(exceptionResult) {
        console.warn('[SelphID] onExceptionCaptured', exceptionResult);
        console.log(`exceptionType: ${exceptionResult.detail.exceptionType}`);
        console.log(`exceptionMessage: ${exceptionResult.detail.message}`);

        if( exceptionResult.detail.message == "Camera not found." || exceptionResult.detail.message.trim() == "Permission denied by system"){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: `No se pudo validar los permisos para acceder a la cámara`,
              confirmButtonColor: '#001b71'
          });
          this.isWidgetCaptureStarted = false;
        }

        this.widgetStartSimpleMode = false;
        //this.isWidgetCaptureStarted = false;
    }

    onExtractionTimeout(eventInfo) {
        console.warn('[SelphID] onExtractionTimeout', eventInfo);
        this.widgetStartSimpleMode = false;
        this.isWidgetCaptureStarted = false;
    }

    public onTrackStatus(eventData) {
        const trackStatusCode = Object.entries(FPhi.SelphID.TrackStatus).find(e => e[1] === eventData.detail.code);
        /*console.warn(`[SelphID] onTrackStatus (Code: ${trackStatusCode[1]} - ${trackStatusCode[0]}, Timestamp: ${eventData.detail.timeStamp}`);
        console.log(eventData);*/
    }

    resizedataURL(datas, wantedWidth, wantedHeight) {
        return new Promise(async function (resolve, reject) {

            // We create an image to receive the Data URI
            let img = document.createElement('img');


            // When the event "onload" is triggered we can resize the image.
            img.onload = function () {
                // We create a canvas and get its context.
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');

                // We set the dimensions at the wanted size.
                canvas.width = wantedWidth;
                canvas.height = wantedHeight;

                // We resize the image with the canvas method drawImage();
                ctx.drawImage(img, 0, 0, wantedWidth, wantedHeight);

                let dataURI = canvas.toDataURL();
                
                // This is the return of the Promise
                resolve(dataURI);
            };

            // We put the Data URI in the image's src attribute
            img.src = datas;

        })
    }

 
}
